'use client'

import * as React from 'react'
import { CustomDomainItem, useCustomDomainsList } from '@/lib/api/domains'
import { useTranslation } from 'react-i18next'
import { DomainListHeader } from './components/domain-list-header'
import { DomainsTable } from './components/DomainsTable'
import { MainTableState } from '@/lib/utils/table-state-utils'
import { TableCard } from '@/components/ui/table-card'
import { DomainDetailModal } from './components/domain-detail-modal'
import { withRequiredPermission } from '@/components/auth/with-required-permission'
import { PERMISSIONS } from '@/hooks/use-perm'

const DomainsPageContainerInner = () => {
	const { t } = useTranslation('domains')

	const [tableState, setTableState] = React.useState<MainTableState>({
		pagination: { pageIndex: 0, pageSize: 10 },
		sorting: [{ id: 'createdAt', desc: true }],
		columnFilters: [],
	})

	const [selectedDomain, setSelectedDomain] = React.useState<CustomDomainItem | null>(null)

	const {
		data: domainsData,
		isLoading: loading,
		isFetching: fetching,
		error,
		refetch,
	} = useCustomDomainsList()

	const domainsList = domainsData?.domains || []
	const total = domainsList.length

	const handleDomainCreated = React.useCallback((_domainName: string) => {
		refetch()
	}, [refetch])

	return (
		<div className="flex flex-col space-y-4 sm:space-y-6">
			<DomainListHeader 
				onDomainCreated={handleDomainCreated}
				domainsList={domainsList}
				setSelectedDomain={setSelectedDomain}
			/>
			<TableCard>
				<DomainsTable
					domains={domainsList}
					total={total}
					loading={loading || fetching}
					onTableStateChange={setTableState}
					onRefetch={refetch}
					selectedDomain={selectedDomain}
					onSelectDomain={setSelectedDomain}
				/>
				{error && (
					<div className="mt-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
						{error instanceof Error ? error.message : t('error')}
					</div>
				)}
			</TableCard>

			<DomainDetailModal
				domain={selectedDomain}
				open={selectedDomain !== null}
				onOpenChange={(open) => !open && setSelectedDomain(null)}
			/>
		</div>
	)
}

export const DomainsPageContainer = withRequiredPermission(DomainsPageContainerInner, PERMISSIONS.STORES_VIEW)

